var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEstado(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.91602 24.067L19.4048 18.6268V14.5878C23.3376 13.9608 26.9157 11.9454 29.4902 8.90691L41.9789 19.1294V9.27548C41.9749 8.51252 41.6694 7.78209 41.1291 7.24344C40.5887 6.70479 39.8573 6.40162 39.0943 6.40002H9.79147C9.03009 6.40403 8.30103 6.70826 7.76264 7.24665C7.22425 7.78504 6.92002 8.5141 6.91602 9.27548V24.067Z",
    fill: "#DB0B33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5205 35.6633H29.6151V8.90692C27.0386 11.9477 23.4568 13.9634 19.5205 14.5878V18.6268L6.91602 24.067V27.966L19.5205 22.4131V18.6268L23.4316 16.8601V20.7712L19.5205 22.544V26.3242L23.5596 24.5575V28.3315L19.5205 30.2353V26.4491L6.91602 31.8771V35.6633L19.5205 30.1104V35.6633Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3952 26.3242V22.538L6.90039 27.966V31.8771L19.3952 26.3242Z",
    fill: "#F0811A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3952 30.2353L6.90039 35.6633H19.3952V30.2353Z",
    fill: "#F0811A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3945 22.5379L23.4305 20.7712V16.8601L19.3945 18.6268V22.5379Z",
    fill: "#F0811A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3945 26.3241V30.2352L23.4305 28.4685V24.5574L19.3945 26.3241Z",
    fill: "#F0811A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6182 35.6633H42.11V19.2574L29.4902 8.90692L29.6182 35.6633Z",
    fill: "#EF801C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4902 35.6633H29.6182L29.4902 8.90692V35.6633Z",
    fill: "#ED6B1D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6151 35.6633H6.91602V38.7093C6.91602 39.476 7.22057 40.2112 7.76268 40.7533C8.30479 41.2954 9.04005 41.6 9.8067 41.6H39.2345C40.0011 41.6 40.7364 41.2954 41.2785 40.7533C41.8206 40.2112 42.1252 39.476 42.1252 38.7093V35.6633H29.6151Z",
    fill: "#0058A6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstado);
export default __webpack_public_path__ + "static/media/estado.aa9f6c046d3d40d1964fd73e036aca9f.svg";
export { ForwardRef as ReactComponent };